(() => {
  const root = window.Shopify?.routes?.root || '/';
  const games = new Set(["4388068032593","8550716309819","10562205614395","10562206171451","10562206925115","10562202337595","10562204303675","6647592681553","8550722404667","8550717653307","8852198129979","8550720733499","8852085571899"]);
  const owned = code => /^(CHATGAMES[234]-(20|30|40)|CHATPAIR50-\d+|CHATADD50-ACTOUT)$/i.test(code);
  let queue = Promise.resolve();
  let holds = 0;
  const begin = () => {
    holds++;
    document.querySelectorAll('[name="checkout"]').forEach(button => {
      if (!button.disabled) { button.dataset.dodTierLock = 'true'; button.disabled = true; }
    });
    return () => {
      holds--;
      if (!holds) document.querySelectorAll('[data-dod-tier-lock]').forEach(button => {
        delete button.dataset.dodTierLock;
        button.disabled = false;
      });
    };
  };
  const request = async (path, data) => {
    const response = await fetch(root + path, data ? {
      method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},
      body:JSON.stringify(data)
    } : {headers:{Accept:'application/json'}});
    const result = await response.json();
    if (!response.ok || result.status || result.errors) throw new Error('Unable to update savings. Please try again.');
    return result;
  };
  const count = cart => cart.items.reduce((sum, item) => {
    const gift = document.querySelector('cart-drawer')?.dataset.giftProduct;
    return sum + (games.has(String(item.product_id)) && String(item.product_id) !== gift && !item.gift_card ? item.quantity : 0);
  }, 0);
  const sync = (original, requestedSections) => {
    const release = begin();
    const run = async () => {
      const cart = await request('cart.js');
      const quantity = count(cart);
      const tier = quantity >= 4 ? 'CHATGAMES4-40' : quantity === 3 ? 'CHATGAMES3-30' : quantity === 2 ? 'CHATGAMES2-20' : '';
      const codes = (cart.discount_codes || []).map(item => item.code);
      const keep = codes.filter(code => !owned(code));
      const desired = [...keep, ...(tier ? [tier] : [])];
      const normalize = values => values.map(value => value.toUpperCase()).sort().join(',');
      if (normalize(codes) === normalize(desired)) return original || cart;
      const sections = requestedSections || Object.keys(original?.sections || {}).length && Object.keys(original.sections) || ['cart-drawer','cart-icon-bubble'];
      const updated = await request('cart/update.js', {discount:desired.join(','),sections,sections_url:location.pathname});
      return {...original,...updated};
    };
    const result = queue.then(run,run);
    queue = result.catch(() => {});
    return result.finally(release);
  };
  window.DODGameTiers = {sync,begin};
  document.addEventListener('submit', async event => {
    if (event.submitter?.name !== 'checkout' || event.submitter.hasAttribute('data-qb-buy-now')) return;
    event.preventDefault();
    if (holds) return;
    try {
      await sync();
      location.assign(root + 'checkout');
    } catch (error) {
      const status = document.querySelector('#CartDrawer-CartErrors, #cart-errors');
      if (status) status.textContent = error.message;
    }
  },true);
  const initialize = async () => {
    try {
      const cart = await sync();
      const drawer = document.querySelector('cart-drawer');
      if (drawer && cart.sections && Object.values(cart.sections).every(Boolean)) {
        drawer.classList.toggle('is-empty', cart.item_count === 0);
        drawer.renderContents(cart,false);
      }
    } catch (error) {
      const status = document.querySelector('#CartDrawer-CartErrors');
      if (status) status.textContent = error.message;
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initialize,{once:true});
  else initialize();
})();
